import AbstractTool from "./AbstractTool";

export default class NavigateTool extends AbstractTool {
    scrollEnabled = true;

    activate() {
        super.activate();
        this.cursor.grab();
    }

    deactivate() {
        super.deactivate();
    }

    dragMouse(event) {
        if (event.target.id == 'defaultCanvas0') {
            this.cursor.grabbing();
            this.view.move(this.p.movedX, this.p.movedY);
        }
    }

    moveMouse() {
        this.cursor.grab();
    }

    getTips() {
        return "Click and drag to move the canvas. CTRL+scroll moves vertically. SHIFT+scroll moves horizontally."
    }

    pressKey(code) {
        switch (code) {
            case 37: // left arrow
                this.view.move(this.arrowMove, 0);
                break;
            case 38: // up arrow
                this.view.move(0, this.arrowMove);
                break;
            case 39: // right arrow
                this.view.move(-this.arrowMove, 0);
                break;
            case 40: // down arrow
                this.view.move(0, -this.arrowMove);
                break;
        }
    }
}
